































































































import CustomFieldListForm from "@/components/report/CustomFieldListForm.vue";
import ReportGroupCreateDialog from "@/components/report/group/ReportGroupCreateDialog.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import MIconButton from "@/components/utility/mmmint/MIconButton.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import RefsReportGroup from "@/components/utility/RefsReportGroup.vue";
import { handleError } from "@/lib/utility/handleError";
import { ReportGoToHelper } from "@/lib/utility/report.go-to-helper";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { CustomFieldValue, ICustomFieldValue } from "@/models/custom-field-value.entity";
import { IReportGroup, ReportGroup } from "@/models/report-group.entity";
import { IReport } from "@/models/report.entity";
import { PartnerModule } from "@/store/modules/partner";
import { ReportGroupModule } from "@/store/modules/report-group.store";
import { debounce } from "debounce";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    MIconButton,
    ReportGroupCreateDialog,
    CustomFieldListForm,
    MNoContent,
    ConfirmActionDialog,
    RefsReportGroup
  },
  filters: {}
})
export default class PartnerReportDetailGroup extends mixins(PermissionMixin) {
  @Prop()
  value!: IReport;

  isLoadingReportGroup = false;

  isLoadingReportGroups = false;

  isLoadingCustomFieldValues = false;

  debounceSaveCustomFields = debounce(this.saveCustomFieldValues, 1000);

  isEditGroupDialogActive = false;

  isEditGroupDialogLoading = false;

  groupCopy: IReportGroup | null = null;

  isSideCardOpen = false;

  get customFieldValues(): ICustomFieldValue[] | undefined {
    return this.value.values;
  }

  set customFieldValues(values: ICustomFieldValue[] | undefined) {
    this.value.values = values;
  }

  get groups() {
    return ReportGroupModule.entities;
  }

  async startEditGroupDialog() {
    this.groupCopy = this.value.group ? new ReportGroup(this.value.group) : null;
    this.isEditGroupDialogActive = true;
    this.isEditGroupDialogLoading = true;
    await this.refreshReportGroups().catch(handleError);
    this.isEditGroupDialogLoading = false;
  }

  goToReportGroupCustomView() {
    if (!this.value.groupId) return;

    new ReportGoToHelper(this.$router).goToReportGroupCustomView({
      partnerId: this.value.partnerId,
      reportGroupId: this.value.groupId,
      viewId: "0",
      newTab: false
    });
  }

  async saveGroup() {
    const selectedGroup = this.groupCopy;

    if (!selectedGroup) throw new Error("No group selected");

    this.isLoadingReportGroup = true;

    await this.value
      .updatePartial({
        groupId: selectedGroup.id
      })
      .catch(handleError);

    this.value.group = selectedGroup;

    this.isLoadingReportGroup = false;
    this.close();
  }

  async saveCustomFieldValues() {
    this.isLoadingCustomFieldValues = true;
    await this.value
      .updatePartial({
        values: CustomFieldValue.buildCustomFieldValuesDto(this.value.values ?? [])
      })
      .catch(handleError);
    this.isLoadingCustomFieldValues = false;
  }

  async refreshReportGroups() {
    this.isLoadingReportGroups = true;
    try {
      ReportGroupModule.setFilters([]);
      await ReportGroupModule.fetchFirstPage({ partnerId: PartnerModule.partner.id });
    } catch (e) {
      handleError(e);
    }
    this.isLoadingReportGroups = false;
  }

  handleGroupChange(groupId: string) {
    this.groupCopy = this.groups.find(g => g.id === groupId) || null;
  }
  close() {
    this.isEditGroupDialogActive = false;
  }
}
